export interface LogoutNavigationResponse {
  logoutUrl: string;
  status?: string;
  frontChannelPost?: boolean;
}

/** Continue the server-approved logout chain without exposing the peer endpoint to GET. */
export function continueLogoutNavigation(
  response: LogoutNavigationResponse | null | undefined,
  fallbackUrl: string
): void {
  const target = response?.logoutUrl || fallbackUrl;
  if (!response?.frontChannelPost) {
    window.location.replace(target);
    return;
  }

  const form = document.createElement('form');
  form.method = 'post';
  form.action = target;
  form.hidden = true;
  document.body.appendChild(form);
  form.submit();
}
